// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c31311ec","524":"4e461de4"}[chunkId] + ".chunk.js";
};